import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate, Button, showNotification, refreshView as refreshViewAction } from 'react-admin';
import compose from 'recompose/compose';

import request from '../../../../network/request';
import resourceConfig from './config';
import checkDocumentBeforeSend from '../../../../utils/checkDocumentBeforeSend';

class SendOrderButton extends Component {
  state = {
    executing: false,
  };
  handleClick = async () => {
    const { showNotification, record, refreshView, translate } = this.props;

    if (!checkDocumentBeforeSend(record, { showNotification, translate })) {
      return;
    }

    this.setState({
      executing: true,
    });

    const { id } = record;
    let data = {
      docId: id,
    };
    let response = null;
    let url = '/admin/out_h/func/send';
    try {
      response = await request({
        apiService: 'shoes',
        path: url,
        urlParams: data,
        method: 'POST',
      });
    } catch (e) {
      console.error(e);
    }
    if (response === null || !response.ok) {
      showNotification(`resources.${resourceConfig.name}.sendDoc.errorMessage`, 'error');
    } else {
      showNotification(`resources.${resourceConfig.name}.sendDoc.successMessage`, 'success');
    }
  };

  render() {
    return (
      <Button
        label={`resources.${resourceConfig.name}.sendDoc.action`}
        disabled={this.state.executing}
        onClick={this.handleClick}
      />
    );
  }
}

export default compose(
  translate,
  connect(undefined, {
    showNotification,
    refreshView: refreshViewAction,
  }),
)(SendOrderButton);
